import { withLocale } from '@/util/categoryRoute'

export default {
  install(app) {
    app.directive('push', {
      mounted(el, binding) {
        el.style.cursor = 'pointer'
        el.addEventListener('click', () => {
          app.config.globalProperties.$router.push({ path: withLocale(binding.value) })
        })
      }
    })
    // 全局挂载
  }
}
